// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"c5ddab3c","400":"9b03f129","760":"61a5bd54"}[chunkId] + ".chunk.js";
};